import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  error: null,
  creatives: [],
};

const creativesSlice = createSlice({
  name: 'creatives',
  initialState,
  reducers: {
    setCreativesLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setCreativesError: (state, action) => {
      state.error = action.payload;
    },
    updateCreativeSuccess: (state, action) => {
      const updatedCreative = action.payload;
      const index = state.creatives.findIndex(
        (creative) => creative.id === updatedCreative.id
      );
      if (index !== -1) {
        state.creatives[index] = updatedCreative;
      }
    },
  },
});

export const {
  setCreativesLoading,
  setCreativesError,
  updateCreativeSuccess,
} = creativesSlice.actions;

export default creativesSlice.reducer;
